module.exports = __webpack_public_path__ + "static/media/plus-light.b2eb1cf4.svg";